<template>
  <section class="hero">
    <div class="hero__glow hero__glow--blue"></div>
    <div class="container">
      <div class="hero__content">
        <span class="hero__tag">下一代数字绘画体验</span>
        <h1 class="hero__title">为创作而生，释放无限灵感</h1>
        <p class="hero__description">
          专业级数字绘画工具，高性能绘画引擎，<br>
          为全球创作者打造极致创作体验
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection'
}
</script>

<style scoped>
.hero {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 120px 0 30px;
}

.hero__glow {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}

.hero__glow--blue {
  width: 450px;
  height: 450px;
  top: -60px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 50%;
  /* background: radial-gradient(circle, rgba(59, 130, 246, 0.25) 0%, rgba(59, 130, 246, 0.08) 40%, rgba(10, 10, 15, 0) 100%); */
  background: radial-gradient(circle, rgba(59, 130, 246, 0.15000000596046448) 0%, rgba(10, 10, 15, 0) 85%);
  filter: blur(40px);
}

.hero__content {
  position: relative;
  z-index: 1;
  text-align: center;
}

.hero__title {
  font-family: 'Inter', sans-serif;
  font-size: 56px;
  font-weight: 700;
  line-height: 1.2;
  color: #FFFFFF;
  max-width: 800px;
  margin: 0 auto 40px auto;
}

.hero__description {
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;
  color: #9CA3AF;
  max-width: 520px;
  margin: 0 auto 0 auto;
}

.hero__tag {
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 500;
  color: #3399FF;
  display: inline-block;
  margin-bottom: 30px;
}

@media (max-width: 1024px) {
  .hero {
    padding: 100px 0 25px;
  }
  .hero__glow--blue {
    width: 350px;
    height: 350px;
    top: -60px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 50%;
    /* background: radial-gradient(circle, rgba(59, 130, 246, 0.25) 0%, rgba(59, 130, 246, 0.08) 40%, rgba(10, 10, 15, 0) 100%); */
    background: radial-gradient(circle, rgba(59, 130, 246, 0.15000000596046448) 0%, rgba(10, 10, 15, 0) 85%);
    filter: blur(30px);
  }
  .hero__title {
    font-size: 40px;
    max-width: 600px;
    margin-bottom: 32px;
  }
  .hero__description {
    font-size: 16px;
    line-height: 26px;
    max-width: 480px;
    margin-bottom: 0;
  }
  .hero__tag {
    font-size: 16px;
  }
}

@media (max-width: 768px) {
  .hero {
    padding: 80px 0 20px;
  }
  .hero__glow--blue {
    width: 280px;
    height: 280px;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 50%;
    /* background: radial-gradient(circle, rgba(59, 130, 246, 0.25) 0%, rgba(59, 130, 246, 0.08) 40%, rgba(10, 10, 15, 0) 100%); */
    background: radial-gradient(circle, rgba(59, 130, 246, 0.15000000596046448) 0%, rgba(10, 10, 15, 0) 85%);
    filter: blur(20px);
  }
  .hero__title {
    font-size: 28px;
    max-width: 100%;
    margin-bottom: 24px;
  }
  .hero__description {
    font-size: 14px;
    line-height: 22px;
    max-width: 100%;
    margin-bottom: 0;
  }
  .hero__tag {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .hero {
    padding: 60px 0 15px;
  }
  .hero__title {
    font-size: 24px;
  }
  .hero__description {
    font-size: 13px;
    line-height: 20px;
  }
}
</style>
